var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"marginTop":"20vh"}},[(!_vm.user)?_c('b-message',{attrs:{"title":"Success","type":"is-success"}},[_vm._v("\n    U bent succesvol afgemeld.\n  ")]):_c('b-message',{attrs:{"title":"Fout","type":"is-warning"}},[_vm._v("\n    Afmelden mislukt.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36073990","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth/AuthLogout.vue
// module id = null
// module chunks = 